import { gsap, Power4 } from 'gsap'

class Hamburger {
  constructor(el) {
    this.dom = {el: el};
    this.dom.trigger = this.dom.el;
    this.dom.menu = document.querySelector('[data-js="menu"]');
    this.dom.closer = document.querySelectorAll('[data-js="closer"]');
    this.dom.body = document.querySelector('body');
    this.dom.cover = document.querySelector('[data-js="menu-cover"]');
    this.dom.coverClip = document.querySelector('[data-js="menu-cover-clip"]');
    // this.dom.changer = this.dom.menu.querySelectorAll('a[href]:not([target])');
    this.dom.changer = this.dom.menu.querySelectorAll('a[href]');

    // this.len = this.dom.cover.length;
    this.isOpen = false;

    this.animHidden = null;

    this.path = {
      reset: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)', 
      open: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
      close: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)'
    }

    this.changeCover = this.changeCover.bind(this);
    this.hiddenCover = this.hiddenCover.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);

    this.mql = window.matchMedia('screen and (min-width: 768px)');
    this.checkBreakPoint = this.checkBreakPoint.bind(this);

    this.init();
  }

  init() {
    this.dom.trigger.addEventListener('click', e => {
      this.toggleMenu();
    });
    [...this.dom.closer].forEach(el=>{
      el.addEventListener('click', e => {
        this.toggleMenu();
      });
    });
    if (window.innerWidth >= 768) {
      [...this.dom.changer].forEach(el => {
        el.addEventListener('mouseenter', this.changeCover);
      });
      [...this.dom.changer].forEach(el => {
        el.addEventListener('mouseleave', this.hiddenCover);
      });
    }

    // ブレイクポイントの瞬間に発火
    this.mql.addListener(this.checkBreakPoint);
    // 初回チェック
    this.checkBreakPoint(this.mql);
  }

  changeCover(e) {
    if (this.animHidden) this.animHidden.kill()

    // 各ディレクトリにある使用する画像ファイル名（拡張子は.jpgで統一）
    const slug = e.currentTarget.dataset.slug;
    const path = e.currentTarget.dataset.path;
    if (slug !== 'none') {
      // リンク先URLを取得して「/」ごとに配列に格納
      const hrefArray = e.currentTarget.href.split('/');
      // ドメイン名までを削除して、画像のパスを生成
      // https://www.furukawaelectric.com/saiyou/recruit/
      // https://dev.skybabies.jp/furukawa-recruiting/
      // http://localhost:5173/
      const charactersToRemove = [`${location.protocol}`, `${location.host}`, 'furukawa-recruiting', 'saiyou', 'recruit', 'www.furukawaelectric.com', 'https:'];
      const setPath = [...hrefArray].filter(char => {
        return !charactersToRemove.includes(char);
      }).join('/');
  
      // 画像のパス生成
      const src = `${path}assets/img${setPath + slug}.jpg?260318`

      const domImage = document.createElement('img');
      domImage.src = src;
      domImage.width = 350;
      domImage.height = 446;
      domImage.alt = '';
      domImage.opacity = 0;

      // srcにパスをセット
      // this.dom.cover.src = src
      gsap.set(domImage, {
        opacity: 0,
      })
      this.dom.coverClip.prepend(domImage);
      
      gsap.to(domImage, {
        opacity: 1,
        duration: .3,
      })

      const removeImage = this.dom.coverClip.querySelector('img:nth-child(2)');
      if (removeImage) {
        gsap.to(removeImage, {
          opacity: 0,
          duration: .3,
          onComplete: () => {
            removeImage.remove();
          }
        })
      }
    } else {
      // slugがnoneの場合は画像非表示
      this.hiddenCover();
    }
  }

  hiddenCover(e) {
    const img = this.dom.coverClip.querySelector('img')
    
    this.animHidden = gsap.to(img, {
      opacity: 0,
      duration: .3,
      delay: .3,
      onComplete: () => {
        if (img) img.remove();
      }
    })
  }

  toggleMenu() {
    if (this.isOpen) {
      this.dom.trigger.setAttribute('aria-expanded', false);
      this.dom.menu.setAttribute('aria-hidden', true);
      this.scrollEnable();
    } else {
      this.dom.trigger.setAttribute('aria-expanded', true);
      this.dom.menu.setAttribute('aria-hidden', false);
      this.scrollDisable();
      // this.changeCover();
    }

    if ( document.body.dataset.isMenu === 'true' ) {
      document.body.removeAttribute('data-is-menu');

      gsap.fromTo(this.dom.menu, {
        clipPath: this.path.open,
      }, {
        clipPath: this.path.close,
        duration: .6,
        // delay: .1,
        ease: Power4.easeInOut,
      })
    } else {

      gsap.fromTo(this.dom.menu, {
        clipPath: this.path.reset,
      }, {
        clipPath: this.path.open,
        duration: .6,
        // delay: .1,
        ease: Power4.easeInOut,
      })
      document.body.dataset.isMenu = 'true';
    }

    this.isOpen = !this.isOpen;
  }

	scrollDisable() {
    document.body.dataset.isScrolldisable = 'true';
	}

	scrollEnable() {
    const _this = this;
    document.body.removeAttribute('data-is-scrolldisable');
	}

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      // console.log('sp');
      return;
    } else {
      // console.log('pc');
      if (this.isOpen) {
        this.dom.trigger.setAttribute('aria-expanded', false);
        this.dom.menu.setAttribute('aria-hidden', true);
        this.scrollEnable();

        this.isOpen = !this.isOpen;
        if( document.body.dataset.isMenu === 'true' ) {
          document.body.removeAttribute('data-is-menu');
        } else {
          document.body.dataset.isMenu = 'true';
        }
      }
      return;
		}
	}
}

export default Hamburger